// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Kxb","icon":"e_Lxb"};